import React from 'react'
import ButtonSpinningLoader from '../ButtonSpinningLoader'
import PropTypes from 'prop-types'

import './button.scss'

/** Button used in most places  */
const Button = ({ children, disabled, thin, variant, className, loading, ...rest }) =>
  <button
    className={`Suc-button Suc-${variant} ${thin ? 'Suc-thin' : ''} ${loading ? 'Suc-loading' : ''} ${className}`}
    disabled={disabled}
    {...rest}
  >{loading ? <ButtonSpinningLoader variant={variant === 'primary' ? 'button-loader' : 'stand-alone'}/> : children}
  </button>

Button.propTypes = {
  /** variant of button */
  variant: PropTypes.oneOf(['primary', 'secondary']),
  /** thin or thick button */
  thin: PropTypes.bool,
  /** disabled state */
  disabled: PropTypes.bool,
  /** loading state */
  loading: PropTypes.bool,
  /** custom classname */
  className: PropTypes.string,
  /** button text */
  children: PropTypes.node
}

Button.defaultProps = {
  variant: 'primary',
  className: '',
  loading: false,
  thin: false,
  disabled: false

}
export default Button
